import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const CierreTurnoApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTotalesProduccion = async () => {
        try {
            setCargando(true);
            const response = await api.get(
                "cierre_turno/get_totales_produccion",
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getPadresProductoTerminado = async (params) => {
        return api
            .get("padres_producto_terminado", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getProductosTrabajadosTurno = async () => {
        return api
            .get("cierre_turno/productos_trabajados_turno")
            .then((data) => data || [])
            .catch(() => {
                return [];
            });
    };

    const cerrarTurno = async (data) => {
        try {
            setCargando(true);

            const response = await api.post(
                `cierre_turno/cerrar_turno`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTotalesProduccion,
        getPadresProductoTerminado,
        getProductosTrabajadosTurno,
        cerrarTurno,

        cargando,
    };
};
